import { ToastModule } from 'primeng/toast';

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon } from '../../ui/svg-icon';

import { Components } from '@/app/core/config';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ToastModule, SvgIcon],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {
  protected readonly config = Components.Toast;
}
